<template>
  <aw-modal
    :modal-title="$awt('aw.common.product.detail.old_product_modal.title')"
    :opened="modal.type === modalType"
    size="sm"
    :closable="modal.item.closable"
  >
    <template #content>
      <aw-separator margin-top="none" />
      <div :class="[$style.modalContent]">
        <div>
          <p :class="[$style.modalText]" v-html="`${$awt('aw.common.product.detail.old_product_modal.text')}${$awt('aw.common.product.detail.old_product_modal.product_name', {productName: productName})}`" />
        </div>
      </div>
      <aw-form v-model="v$" :class="$style.oldProductForm" @on-submit="onSubmit">
        <div :class="$style.oldProductFormRow">
          <div
            v-for="(item, index) in oldProducts"
            :key="index"
            :class="$style.oldProductFormRowItem"
          >
            <aw-checkbox-version2
              v-model="oldProduct"
              :has-label="true"
              :label="item.label"
              :value="item"
            />
          </div>
        </div>
        <aw-separator />
        <aw-form-button v-model="v$" :shrink="!screenRange['sm-max']" styling="primary-dark">
          {{ $awt('aw.common.product.detail.old_product_modal.btn') }}
        </aw-form-button>
      </aw-form>
    </template>
  </aw-modal>
</template>

<script setup>
  import { useNuxtApp } from 'nuxt/app';
  import AwModal from '~~/common/components/Common/AwModal';
  import AwForm from '~~/common/components/Form/AwForm';

  import AwFormButton from '~~/common/components/Form/AwFormButton';
  import AwCheckboxVersion2 from '~~/common/components/Common/Widgets/AwCheckboxVersion2';

  import { useModalStore } from '~~/common/stores/modal';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';
  import { useVuelidate } from '@vuelidate/core';
  import AwSeparator from '~~/common/components/Common/AwSeparator.vue';

  const { $awt } = useNuxtApp();

  defineProps({
    modalType: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
  });

  const emits = defineEmits([
    'return-used-item',
  ]);

  const v$ = useVuelidate();

  const selectedOption = ref(2);
  const oldProducts = ref([
    {
      label: $awt('aw.common.product.detail.old_product_modal.delivery'),
      value: 1,
    },
    {
      label: $awt('aw.common.product.detail.old_product_modal.not_delivery'),
      value: 2,
    },
  ]);

  const modal = computed(() => {
    return useModalStore().activeGenericModal;
  });

  const screenRange = computed(() => {
    return useUserInterfaceStore().mediaQueries;
  });

  const oldProduct = computed({
    get () {
      return oldProducts.value.find(item => item.value === selectedOption.value);
    },
    set (newVal) {
      if (newVal !== '') {
        selectedOption.value = oldProducts.value.find(item => item.value === newVal.value).value;
      }
    },
  });

  function onSubmit () {
    emits('return-used-item', selectedOption.value === 1);
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.row {
  margin: 32px 0;
}

.centerItem {
  text-align: center;
}

.modalContent {
  display: flex;
  justify-content: center;

  @include sm(max) {
    padding: 0 24px;
  }

  .modalText {
    margin-bottom: 36px;

    @include lg(min) {
      margin-bottom: 44px;
    }

    strong {
      font-weight: $font-weight-bold;
    }
  }

  .modalTitle {
    margin-bottom: 32px;
  }
}

.oldProductForm {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &Row {
    display: flex;
    justify-content: center;
    gap: 12px;

    @include lg(min) {
      margin-bottom: 36px !important;
    }

    &Item {
      margin-bottom: 40px;

      @include lg(min) {
        margin-bottom: 0;
      }
    }
  }

  > button {
    align-self: center;
  }
}

</style>
